export default class ReverseGeocodingService {
    static BASE_URL = 'https://nominatim.openstreetmap.org/reverse';

    /**
     * Performs reverse geocoding given a [lat, lon] coordinate.
     * @param {number[]} latlng - [latitude, longitude]
     * @returns {Promise<Object>} - Address info including country, state, and locality
     */
    static async getAddress(latlng) {
        if (!Array.isArray(latlng) || latlng.length !== 2) {
            throw new Error('Invalid latlng parameter. Expected [lat, lon].');
        }

        const [lat, lon] = latlng;

        try {
            const res = await fetch(
                `${this.BASE_URL}?format=geocodejson&lat=${lat}&lon=${lon}`,
                {
                    headers: {
                        'User-Agent': 'app/1.0',
                    },
                }
            );

            if (!res.ok) {
                throw new Error(`Nominatim request failed with status ${res.status}`);
            }

            const data = await res.json();
            const feature =
                data && data.features && data.features.length > 0
                    ? data.features[0]
                    : null;

            const props = feature && feature.properties ? feature.properties : {};
            const addr = props.geocoding ? props.geocoding : {};

            return {
                country: addr.country || null,
                state: addr.state || null,
                locality:
                    addr.district ||
                    addr.county ||
                    addr.city ||
                    addr.town ||
                    addr.village ||
                    null,
                raw: addr, // optional: return full address data
            };
        } catch (error) {
            console.error('Reverse geocoding failed:', error);
            throw error;
        }
    }
}
